'use strict';

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('fpx'),
    call = _require.call,
    slice = _require.slice,
    isFunction = _require.isFunction,
    validate = _require.validate;

var _require2 = require('./subscription'),
    Subscription = _require2.Subscription;

var _require3 = require('./lifetime'),
    _deinit = _require3.deinit;

var _require4 = require('./utils'),
    _pull = _require4.pull,
    flushBy = _require4.flushBy,
    forceEach = _require4.forceEach;

var Que = function () {
  function Que(deque) {
    _classCallCheck(this, Que);

    validate(isFunction, deque);
    this.state = this.states.IDLE;
    this.pending = [];
    this.deque = deque;
  }

  Que.prototype.push = function push(value) {
    this.pending.push(value);
    if (this.state === this.states.IDLE) this.flush();
  };

  Que.prototype.pull = function pull(value) {
    _pull(this.pending, value);
  };

  Que.prototype.dam = function dam() {
    if (this.state === this.states.IDLE) this.state = this.states.DAMMED;
  };

  Que.prototype.flush = function flush() {
    if (this.state === this.states.FLUSHING) return;
    this.state = this.states.FLUSHING;
    try {
      flushBy.call(this, this.pending, deque);
    } finally {
      this.state = this.states.IDLE;
    }
  };

  Que.prototype.isEmpty = function isEmpty() {
    return !this.pending.length;
  };

  Que.prototype.isDammed = function isDammed() {
    return this.state === this.states.DAMMED;
  };

  Que.prototype.deinit = function deinit() {
    this.pending.splice(0);
  };

  return Que;
}();

exports.Que = Que;

Que.prototype.states = {
  IDLE: 'IDLE',
  DAMMED: 'DAMMED',
  FLUSHING: 'FLUSHING'
};

// Masks extra args from flushBy
function deque(value) {
  this.deque(value);
}

var TaskQue = function (_Que) {
  _inherits(TaskQue, _Que);

  function TaskQue() {
    _classCallCheck(this, TaskQue);

    return _possibleConstructorReturn(this, _Que.call(this, call));
  }

  TaskQue.prototype.push = function push(fun) {
    validate(isFunction, fun);
    var task = fun.bind.apply(fun, [this].concat(slice(arguments, 1)));
    _Que.prototype.push.call(this, task);
    return _Que.prototype.pull.bind(this, task);
  };

  return TaskQue;
}(Que);

exports.TaskQue = TaskQue;

var MessageQue = function (_TaskQue) {
  _inherits(MessageQue, _TaskQue);

  function MessageQue() {
    _classCallCheck(this, MessageQue);

    var _this2 = _possibleConstructorReturn(this, _TaskQue.call(this));

    _this2.subscriptions = [];
    return _this2;
  }

  MessageQue.prototype.push = function push() {
    _TaskQue.prototype.push.call(this, triggerSubscriptions, arguments);
  };

  MessageQue.prototype.subscribe = function subscribe(callback) {
    var sub = new Subscription(this, callback);
    this.subscriptions.push(sub);
    return sub;
  };

  MessageQue.prototype.unsubscribe = function unsubscribe(sub) {
    _pull(this.subscriptions, sub);
  };

  MessageQue.prototype.deinit = function deinit() {
    _TaskQue.prototype.deinit.call(this);
    flushBy(this.subscriptions, _deinit);
  };

  return MessageQue;
}(TaskQue);

exports.MessageQue = MessageQue;

function triggerSubscriptions(args) {
  forceEach(this.subscriptions.slice(), triggerSubscription, args);
}

function triggerSubscription(subscription, args) {
  subscription.trigger.apply(subscription, args);
}


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/ques.js
// module id = 911
// module chunks = 118